// @flow
import React, { Component } from 'react';
import { blender } from '../../utils/blender';
import CatalogGrid from '../../components/CatalogCard/CatalogGrid';
import isEqual from 'react-fast-compare';
import ItemGrid from '../../components/ItemCard/ItemGrid';
import PaginationWrapper from '../../components/Pagination/PaginationWrapper';
import { preventDefault } from '../../utils/preventDefault';
import styles from './SearchResults.module.scss';

const VIEWS_TO_SHOW = [24, 48, 72, 96, 120];

type Props = {
    baseUrl: string,
    canonicalURL?: string,
    catalogs?: any[],
    changePageAndNavigate: Function,
    changePageSizeAndNavigate: Function,
    items?: any[],
    page: number,
    pageSize: number,
    pathname: string,
    promotedItems: any[],
    totalItemsFound: number,
    totalPages?: number,
    trackItemClick?: Function,
    trackUpcomingCatalogClick?: Function,
    width: number,
};

export default class SearchResults extends Component<Props> {
    static defaultProps = {
        promotedItems: [],
    };

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    preventDefault = preventDefault;

    render() {
        const {
            baseUrl,
            catalogs,
            canonicalURL,
            changePageSizeAndNavigate,
            changePageAndNavigate,
            items,
            page,
            pageSize,
            pathname,
            promotedItems,
            totalItemsFound,
            totalPages,
            width,
        } = this.props;

        let columns = width < 550 ? 2 : 3;
        columns = width > 767 ? 2 : columns;
        columns = width > 820 ? 3 : columns;
        // TODO: switch to 4 columns eventually
        // columns = width > 1099 ? 4 : columns;

        const markedPromotedItems = promotedItems.map(pi => {
            pi.promoted = true;
            return pi;
        });
        const mixedItems: any[] = blender(items, markedPromotedItems, columns) || [];
        const indexedItems: any[] = mixedItems.map((item, itemIndex) => {
            item.index = (page - 1) * pageSize + itemIndex;
            return item;
        });

        return (
            <div className={styles.results}>
                {catalogs ? (
                    <CatalogGrid
                        cardViewModels={catalogs}
                        catalogCardClass={styles['catalog-cards']}
                        className={styles.grid}
                        trackClick={this.props.trackUpcomingCatalogClick}
                    />
                ) : (
                    <ItemGrid
                        // allowBidding
                        cardViewModels={indexedItems}
                        className={styles.grid}
                        hideLotNumbers
                        itemCardClass={styles.cards}
                        showImageWithHover
                        trackClick={this.props.trackItemClick}
                    />
                )}
                <PaginationWrapper
                    availableViews={VIEWS_TO_SHOW}
                    baseUrl={baseUrl}
                    canonicalURL={canonicalURL}
                    onPageChange={changePageAndNavigate}
                    onPageSizeChange={changePageSizeAndNavigate}
                    onSubmit={this.preventDefault}
                    page={page}
                    pageSize={pageSize}
                    paginatorOverrideClass={styles.paginator}
                    paginatorContainerOverrideClass={styles['paginator-container']}
                    paginatorViewCountOverrideClass={styles['pagination-view-count']}
                    pathname={pathname}
                    totalItemsCount={totalItemsFound}
                    filteredItemCount={totalItemsFound}
                    totalPages={totalPages}
                />
            </div>
        );
    }
}
